export default {
  more: "Ավելին",
  freeUser: "Անվճար",
  at: "ատ",
  days: "օր",
  serviceUnavailable: "ծառայությունն անհասանելի է",
  serviceUnavailableCapitalize: "Ծառայությունն անհասանելի է",
  room: "Կաբինետ",
  Chief: "Ղեկավար",
  Admin: "Ադմինիստրատոր",
  Manager: "Մենեջեր",
  heading: "Բաց մի թողեք հաղորդագրությունները",
  text: "Միացրեք ծանուցումները։ Բրաուզերը կհարցնի ծանուցումներն ուղարկելու թույլտվություն՝ թույլատրեք։ Այդ հաղորդագրությունից հետո ԱՏԻ-ից ծանուցումներ կհայտնվեն էկրանի ներքևում՝ անկախ նրանից թե որ կայքում եք գտնվում:",
  btnText: "միացնել ծանուցումները",
  importantMessagesPluralize: {
    one: "կարևոր հաղորդագրություն(ներ)",
    few: "կարևոր հաղորդագրություն",
    many: "կարևոր հաղորդագրություն(ներ)",
    other: "կարևոր հաղորդագրություն(ներ)",
  },
  CoWorker: "Աշխատակից",
  score: "Հաշիվ",
  firman: "Լիցենզիաներ",
  paidFor: "Վճարված է մինչև",
  add: "Ավելացնել",
  extend: "Երկարացնել",
  freeAccess: "Դուք ունեք անվճար մուտք",
  licenseDescr:
    "Դուք կարող եք դիտել միայն անվճար մեքենաներն ու բեռները։ Ամեն ինչ տեսնելու համար գնեք լիցենզիա։",
  whatLicensed: "Ուրիշ ի՞նչ հնարավորություններ են տալիս լիցենզիաները:",
  selectLicense: "Ընտրել լիցենզիա",
  settings: "Կարգավորել",
  recurrentPaymentFailed: "Չհաջողվեց ելքագրել ավտովճարումը",
  moreInfo: "Մանրամասն",
  pay: "Վճարել",
  conditions: "Պայմանները",
  logout: "Ելք",
  view: "Դիտել",
  readLater: "Կկարդամ ավելի ուշ",
  participantsSearch: "ԱՏԻ մասնակիցների որոնում",
  advancedSearch: "Ընդյլայնված որոնում",
  advanced: "Ընդլայնված",
  cannotFindFirm: "Մենք չգտանք այդպիսի մասնակից։",
  somethingWentWrong: "Ինչ-որ բան այն չէ։",
  somethingWentWrongWithoutDot: "Ընդլայնված որոնման հետ",
  byExtendedSearch: "ինչ-որ բան այն չէ։",
  tryUsing: "Փորձեք օգտվել",
  notificationSettings: "Ծանուցումների կարգավորումներ",
  noNewNotifications: "Նոր ծանուցումներ չկան",
  viewedNotifications: "Ընթերցված ծանուցումներ",
  downloadLoadsAndTrucks: "Բեռնեք ԱՏԻ Բեռները և Տրանսպորտը",
  receiveNotifications:
    "Ստացեք նոր բեռների վերաբերյալ ծանուցումներ ձեր հեռախոսին կամ պլանշետին",
  forAndroid: "Android",
  forIPhoneIPad: "IPHONE ԵՎ IPAD",
  markAllAsRead: "Բոլորը նշել՝ որպես ընթերցված",
  soundOn: "Միացնել ձայնը",
  soundMute: "Անջատել ձայնը",
  loads: "Բեռներ",
  transport: "Տրանսպորտ",
  checks: "Ստուգումներ",
  tenders: "Տենդերներ",
  news: "Նորություններ",
  forums: "Ֆորումներ",
  docs: "Դոկի",
  atiDocs: "ԱՏԻ-Դոկի",
  tracking: "Մոնիթորինգ",
  shipmentTracking: "GPS-մոնիթորինգ",
  insurance: "Սպահովագրություն",
  ratingOfParticipants: "Վարկանիշ",
  contacts: "Կոնտակտներ",
  loans: "Փոխառություններ",
  truckmarket: "Տրանսպորտի վաճառք",
  yourLoads: "Ձեր բեռները",
  addLoad: "Ավելացնել բեռ",
  searchLoads: "Գտնել բեռներ",
  load: "Բեռ",
  yourTrucks: "Ձեր մեքենաները",
  addTruck: "Ավելացնել մեքենա",
  searchTrucks: "Գտնել մեքենաներ",
  truck: "Մեքենա",
  orders: "Պատվերներ",
  ordersFromYou: "Պատվերներ ձեր կողմից",
  ordersToYou: "Պատվերներ ձեզ",
  ordersToDriver: "Заявка водителю", // !
  vehicleFleet: "Ավտոպարկ",
  drivers: "Վարորդներ",
  organizations: "Կազմակերպություններ",
  contractors: "Կոնտրագենտներ և պայմանագրեր",
  boards: "Հարթակներ",
  yourBoards: "Ձեր հարթակները",
  invitationsAndApplications: "Հրավերներ և հայտեր",
  youParticipate: "Դուք մասնակցում եք",
  invitations: "Հրավերներ",
  aboutBoards: "Հարթակների մասին",
  yourTenders: "Ձեր Տենդերները",
  addTenders: "Ավելացնել տենդեր",
  catalogs: "Տեղեկատուներ",
  directionsLists: "Ուղղությունների ցուցակներ",
  companiesList: "Ֆիրմաների ցուցակներ",
  requisites: "Ձեր ռեկվիզիտները",
  registration: "Գրանցում",
  toRegister: "Գրանցվել",
  login: "մուտք",
  toLogin: "մուտք գործել",
  code: "Կոդ",
  copied: "պատճենված է",
  cars: "Մեքենաներ",
  rating: "Վարկանիշ",
  veh: "ՏՄ",
  guaranteedPayment: "Երաշխավորված վճարում",
  daysRemaining: ["օր", "օր", "օր"],
  remain: ["մնացել է", "մնացել է"],
  paymentHaveToBeReceived: "Վճարումը պետք է ստացվի մինչև",
  paymentHadToBeReceived: "Վճարումը պետք է ստացվեր մինչև",
  expired: "ժամկետանց է",
  avatar: "Ավատար",
  accountReplenishment: "Համալրել հաշիվը",
  from: "սկսած",
  rub: "ռուբ",
  aMonth: "ամսական",
  profile_freeAccessTooltip:
    "-Եթե դուք ակտիվացնեք մեքենաներ կամ բեռներ դիտելու լիցենցիան, դուք կարող եք՝",
  viewContactsForCarsAndCargoes: "Դիտել մեքենաների և բեռների կոնտակտները",
  viewPassports:
    "Դիտել ATI.SU մասնակիցների անձնագրերը՝ կարծիքներով և բողոքներով",
  yourContact: "Ձեր կոնտակտը",
  noLicenseInfo:
    "Գործող լիցենզիաների վերաբերյալ տեղեկատվությունը ժամանակավորապես անհասանելի է",
  shortMonths: {
    0: "հունվ․",
    1: "փետր․",
    2: "մարտ",
    3: "ապր․",
    4: "մայիսի",
    5: "հունիսի",
    6: "հուլիսի",
    7: "օգ․",
    8: "սեպ․",
    9: "հոկ․",
    10: "նոյ․",
    11: "դեկ․",
  },

  /** месяца в родительном падеже */
  januaryGen: "հունվարի",
  februaryGen: "փետրվարի",
  marchGen: "մարտի",
  aprilGen: "ապրիլի",
  mayGen: "մայիսի",
  juneGen: "հունիսի",
  julyGen: "հուլիսի",
  augustGen: "օգոստոսի",
  septemberGen: "սեպտեմբերի",
  octoberGen: "հոկտեմբերի",
  novemberGen: "նոյեմբերի",
  decemberGen: "դեկտեմբերի",

  year: "թ.",

  recommendChangingBrowser: "Խորհուրդ ենք տալիս փոխել բրաուզերը",
  someSiteFeaturesMayNotWorkInThe:
    "Կայքի գործառույթների մի մասը կարող է չաշխատել",
  thatYouAreUsing: ", որը դուք օգտագործում եք։",
  download: "Բեռնել",
  notificationsPluralize: {
    few: "նոր ծանուցում",
    many: "նոր ծանուցում",
    one: "նոր ծանուցում",
    other: "նոր ծանուցում",
  },
  messagesPluralize: {
    oneNumber: "նոր հաղորդագրություն",
    fewNumbers: "նոր հաղորդագրություն",
    manyNumbers: "նոր հաղորդագրություն",
    other: "նոր հաղորդագրություն",
  },
  remainPluralize: {
    one: "մնացել է",
    few: "մնացել է",
    many: "մնացել է",
    other: "մնացել է",
  },
  daysRemainingPluralize: {
    one: "օր",
    few: "օր",
    many: "օր",
    other: "մնացել է",
  },
  contactsByLicense: {
    one: "լր. կոնտակտ",
    few: "լր. կոնտակտի",
    many: "լր. կոնտակտների",
    other: "լր. կոնտակտ",
  },
  youHave: "Ձեզ մոտ",
  allRead: "Բոլորը ընթերցված են",
  createBoard: "Ստեղծել Հարթակ",
  unreadNotifications: "Չընթերցված ծանուցումներ",
  noUnreadNotifications: "Ընթերցած ծանուցումներ չկան",
  notifications: "ծանուցում",
  atiMessenger: "ԱՏԻ Մեսենջեր",
  viewUnread: "Դիտել չընթերցվածները",
  readAll: "Դիտել բոլորը",
  viewAll: "Ընթերցել բոլորը",
  automaticPaymentEnabled: "Միացված է ավտովճարումը",
  clickBackAndTryAgain: "Սեղմեք Հետ և փորձեք ևս մեկ անգամ:",
  back: "Հետ",
  sorrySomethingWentWrong: "Ինչ-որ բան այն չէ",
  loadingError: "Բեռնման սխալ։",
  addingNewLicensesWillBeAvailableAfterRenewal:
    "Նոր լիցենզիաների ավելացումը հասանելի կլինի երկարաձգումից հետո",
  searchParticipants: "Մասնակիցների որոնում",
  stars: "Աստղեր",
  refresh: "Թարմացնել",
  loadsOnBoards: "Բեռները հարթակներում",
  sorrySomethingWentWrongPleaseTryAgain:
    "Ինչ-որ բան այն չէ, փորձեք ևս մեկ անգամ",
  participantHasNoPaidLicenses: "Օգտատերը չունի վճարված լիցենզիաներ",
  anErrorHasOccurredRefreshThePage: "Տեղի է ունեցել սխալ։ Թարմացրեք էջը",
  supportNGINX:
    "ԱվտոՏրանսԻնֆո՝ միլիոնավոր ծառայություններից մեկն է, որոնք օգտագործում են NGINX. Open-source տեխնոլոգիաները պետք է բաց լինեն։",
  browserIsNotOptimal:
    "Ձեր բրաուզերը օպտիմալ չէ ԱՏԻ-ի հետ աշխատանքի համար։ Ներբեռնեք ուրիշը",
  weRecommend: "Մենք խորհուրդ ենք տալիս",
  or: "կամ",
  theSiteWillWorkMoreStable: "Դրանցով կայքն ավելի կայուն կաշխատի",
  ICantUseAnotherBrowser: "Ես չեմ կարող օգտագործել այլ բրաուզեր",
  howToInstallAnotherBrowser: "Ինչպես տեղադրել այլ բրաուզեր",
  tnxForVote: "Շնորհակալություն ձայնի համար",
  confirm: "Հաստատել",
  resend: "Կրկին ուղարկել",
  sendCode: "Ուղարկել կոդը",
  cancel: "Չեղարկում",
  codeSent: "Կոդն ուղարկված է",
  codeSentOnNewEmail: "Նոր փոստին ուղարկվել է նամակ՝ հաստատման կոդով",
  resendAgain: "Կրկին ուղարկել",
  seconds: "վրկ․ անց",
  loanAvailable: "Ձեզ հասանելի է",
  cargoOwnerButtonAvailable: "ATI.SU с нуля",
  youCan: "Դուք կարող եք",
  unsubscribeFrom: "ապաբաժանորդագրվել",
  turnPartnerOffers: "կամ անջատել գործընկերների բոլոր առաջարկները",
  inNotificationSettings: "ծանուցումների կարգավորումներում",
  youCanUnsubscribeFromPartners:
    "Դուք կարող եք ապաբաժանորդագրվել  ATI.SU-ի գործընկերների առաջարկներից {{inSettings}}",

  allServices: "Բոլոր ծառայությունները",

  automationHeader: "Փոխադրումների ավտոմատացում",
  statisticHeader: "Վիճակագրություն",
  securityHeader: "Անվտանգություն",
  comunicationHeader: "Շփում",
  addInstrumentsHeader: "Լր․ գործիքներ",
  usefulHeader: "Օգտակար",

  apiLink: "API ATI.SU",
  apiLinkDescription: "Ձեր կորպորատիվ ԾԱ ինտեգրեք ATI.SU ծառայությունների հետ",
  automationLink: "Ավտոմատացում",
  gpsLink: "GPS-մոնիթորինգ",
  gpsDescription:
    "Առցանց հետևեք տրանսպորտի գտնվելու վայրին և փոխադրման կարգավիճակին",
  docsLink: "ԱՏԻ–Դոկի (ԷՓ)",
  docsDescription:
    "Ստեղծեք և գործընկերների հետ փոխանակեք էլեկտրոնային փաստաթղթերը",
  ordersLink: "Պատվերներ",
  ordersDescription:
    "Ամբողջությամբ ավտոմատացրեք փոխադրումները՝ գործընկերների որոնումից մինչև վերլուծություն",
  boardsLink: "ATI.SU հարթակներ",
  boardsDescription: "Ստեղծեք վստահելի գործընկերների հետ աշխատանքի ձեր հարթակը",
  tendersLink: "Տենդերներ",
  tendersDescription:
    "Կնքեք տասնյակ և հարյուրավոր փոխադրումների համար երկարաժամկետ պայմանագրեր",
  auctionLink: "Աճուրդներ",
  auctionDescription: "Բեռի համար գտեք օպտիմալ գին",
  indexLink: "ՌԴ ATI.SU FTL ինդեքս",
  indexDescription: "Դրույքաչափերի դինամիկան ՌԴ ամենահայտնի ուղղություններով",
  middlePriceLink: "Միջին դրույքաչափեր",
  middlePriceDescription:
    "Ակտուալ դրույքաչափեր՝ ռուբ/կմ-ով ՌԴ հազարավոր ուղղություններով",
  cargoMapLink: "Բեռների քարտեզ",
  profitableDestinationsLink: "Շահավետ ուղղություններ",
  profitableDestinationsDesription: "",
  unlimitedCheckLink: "Կոնտրագենտների անսահմանափակ ստուգում",
  unlimitedCheckDescription:
    "Անվտանգության ազդանշան + հաշվետվություն + ՌԴ ֆիրմաների ընդյալյնված վերլուծություն",
  guaranteePaymentLink: "Փոխադրման վճարի երաշխիք",
  guaranteePaymentDescription: "",
  checkLink: "ATI.SU ստուգումներ",
  checkShortLink: "ստուգումներ",
  checkDescription:
    "Ստուգեք իրավաբանական անձը, ֆիզիկական անձը կամ ՏՄ՝ բեռից կամ վճարումից չզրկվելու համար",
  trafficLightLink: "Լուսացույց+",
  trafficLightDescription:
    "Անվտանգության ազդանշան + Ռուսաստանի և Ղազախստանի ֆիրմաների հաշվետվություն",
  messengerLink: "ԱՏԻ Մեսենջեր",
  messengerDescription:
    "Պայմանավորվեք փոխադրման մասին, ATI.SU մասնակցին ուղարկեք լուսանկարներ և փաստաթղթեր",
  forumsLink: "Ֆորումներ",
  forumsDescription: "Քննարկեք նորություններ, փոխանակվեք փորձով և կարծիքներով",
  realTruckLink: "Ակտիվ փոխադրողների որոնում",
  realTruckDescription: "Եթե բեռը երկար չի շարժվում՝ գտեք հարմար փոխադրողի",
  distanceCalculatorLink: "Հեռավորությունների հաշվարկ",
  distanceCalculatorDescription: "Պլանավորեք բեռնատարի երթուղին",
  chainsLink: "Բեռների շղթաներ",
  chainsDescription: "Կառուցեք առավելագույն դրույքաչափով առավել շահավետ շղթա",
  academyLink: "ATI.SU ակադեմիա",
  academyDescription: "Սովորեք արդյունավետ լուծել լոգիստիկ խնդիրները",
  loansLink: "Փոխառություններ",
  loansDescription: "Հատուկ պայմաններ ԱՏԻ մասնակիցների համար",
  newsLink: "Նորություններ",
  newsDescription:
    "Առաջինը իմացեք աշխարհում բեռնափոխադրումների վերաբերյալ ամենակարևոր նորությունների մասին",
  partnershipLink: "Ռեֆերալ ծրագիր",
  partnershipDescription: "Հրավիրեք նոր օգտատերերի և վաստակեք մեզ հետ միասին",
  ratingLink: "ATI.SU մասնակիցների վարկանիշ",
  ratingDescription: "Գտեք ձեր տարածաշրջանի լավագույն մասնակիցներին",
  insuranceLink: "Ապահովագրություն",
  insuranceDescription:
    "Ապահովագրեք բեռը կամ պատասխանատվությունը մի քանի քլիքով",
  truckmarketLink: "Տրանսպորտի վաճառք",
  truckmarketDescription:
    "Վաճառեք, գնեք կամ վարձակալեք տրանսպորտ և հատուկ տեխնիկա",
  timeSlots: "ժամանակավոր պատուհաններ",
  timeSlotsDescription:
    "Կազմակերպեք պահեստի արդյունավետ աշխատանքը առանց հերթերի և տուգնանքների",
  partnersOffers: "Գործընկերների հատուկ առաջարկները",
  catalogsLink: "Տեղեկատուներ",
  ticketsLink: "Դիմումներ (թիքեթներ)",
  courierLink: "ԱՏԻ առաքիչ",

  loadsSearch: "Բեռների որոնում",
  mainMenu_loads: "Բեռներ",
  trucksSearch: "Մեքենաների որոնում",
  mainMenu_trucks: "Մեքենաներ",

  mainMenu_atiDocs_short: "ԱՏԻ-Դոկի",

  cargoOwners: "Բեռի սեփականատերերին",

  submenu_codeCopied: "Կոդը կրկնօրինակվել է",

  menu_section_loadsAndOrders: "մեքենաներ եվ պատվերներ",
  menu_addLoad: "Ավելացնել բեռ",
  menu_yourLoads: "Ձեր բեռները",
  menu_yourTenders: "Ձեր տենդերները",
  menu_addTenders: "Ավելացնել տենդեր",
  menu_yourOrders: "Պատվերներ ձեր կողմից",
  menu_reports: "Հաշվետվություններ",
  menu_billing: "Վճարել ATI.SU",

  menu_section_boards: "Հարթակներ",
  menu_invitations: "Հրավերներ",
  menu_yourBoards: "Ձեր հարթակները",
  menu_youParticipate: "Դուք մասնակցում եք",
  menu_createBoard: "Ստեղծել Հարթակ",
  menu_boards: "Հարթակներ",

  menu_section_carrierSearch: "Փոխադրողների որոնում",
  menu_trucksSearch: "Գտնել մեքենա",
  menu_activeCarriers: "Ակտիվ փոխադրողներ",
  menu_rating: "Մասնակիցների վարկանիշ",
  menu_safetyMemo: "Անվտանգության հուշագիր",

  menu_section_catalogs: "Տեղեկատուներ",
  menu_organizations: "Կազմակերպություններ",
  menu_partnersAndContracts: "Կոնտրագենտներ և պայմանագրեր",
  menu_yourRequisites: "Ձեր ռեկվիզիտները",
  menu_firmLists: "Ֆիրմաների ցուցակներ",
  menu_directionLists: "Ուղղությունների ցուցակներ",
  menu_catalogs: "Ձեր տեղեկատուները",
  menu_drivers: "Վարորդներ",

  carriers: "Փոխադրողներին",

  menu_section_trucksAndOrders: "Մեքենաներ և պատվերներ",
  menu_addTruck: "Ավելացնել մեքենա",
  menu_yourTrucks: "Ձեր մեքենաները",
  menu_ordersToYou: "Պատվերներ ձեզ",

  menu_section_loadsSearch: "Բեռների որոնում",
  menu_loadsSearch: "Բեռների որոնում",
  menu_cargoChains: "Բեռների շղթաներ",
  menu_boardsSearch: "Հարթակներ",

  menu_boardsLoadsSearch: "Բեռները Հարթակներում",

  menu_section_trucksSearch: "Փոխադրողների որոնում",
  menu_exchange: "ATI.SU բորսա",
  menu_gps: "GPS-մոնիթորինգ",

  menu_section_usefull: "օգտակար",

  menu_section_yourDocuments: "Ձեր փաստաթղթերը",
  menu_section_rouming: "Ռոումինգ",
  menu_section_createDocument: "Ստեղծել փաստաթուղթ",
  menu_inbox: "Մուտքային",
  menu_awaitingDecision: "Սպասում են որոշման",
  menu_closing: "Փակվող ATI.SU-ի կողմից",
  menu_yourCounterparties: "Ձեր կոնտրագենտները",
  menu_yourCertificates: "ԷՍ ձեր վկայականները",
  menu_invoice: "Հաշիվ՝ վճարման համար",
  menu_applicationAgreement: "Պայմանագիր-հայտ",
  menu_certificateOfCompletion: "Կատարված աշխատանքների փաստաթուղթ",
  menu_otherDocument: "Այլ փաստաթուղթ",

  menu_add_order: "Ավելացնել հայտ վարորդին",

  burger_addLoad: "Ավելացնել բեռ",
  burger_addTruck: "Ավելացնել մեքենա",

  bottom_yourLoad: "Ձեր բեռները",
  bottom_loads: "Բեռներ",
  bottom_yourTrucks: "Ձեր մեքենաները",
  bottom_trucks: "Մեքենաներ",
  bottom_services: "Ծառայություններ",
  bottom_orders: "Պատվերներ",
  bottom_profile: "Պրոֆիլ",

  mainMenu_atiDocs: "ԱՏԻ-Դոկի(ԷՓ)",

  profile_serviceUnavailable: "Ծառայությունն անհասանելի է",
  profile_freeUser: "Անվճար",
  profile_atis: "ատ",
  profile_days: "օր",
  profile_yourContact: "Ձեր կոնտակտը",
  profile_refresh: "Թարմացնել",
  profile_score: "Հաշիվ",
  profile_room: "Կաբինետ",
  profile_logout: "Ելք",
  profile_freeAccess: "Դուք ունեք անվճար մուտք",
  profile_freeAccessText:
    "Դուք կարող եք դիտել միայն անվճար մեքենաներն ու բեռները։ Ամեն ինչ տեսնելու համար գնեք լիցենզիա։",
  profile_whatsMore: "Ուրիշ ի՞նչ հնարավորություններ են տալիս լիցենզիաները:",
  profile_selectLicense: "Ընտրել լիցենզիա",
  profile_fromPerMonth: "Ամսական սկսած 460 ₽-ից",
  profile_payBefore: "Վճարել մինչև {{val}}",
  profile_guaranteedPayment: "Երաշխավորված վճարում։",
  profile_remainPluralize: {
    one: "մնացել է",
    few: "մնացել է",
    many: "մնացել է",
    other: "մնացել է",
  },
  profile_daysRemainingPluralize: {
    one: "օր",
    few: "օր",
    many: "օր",
    other: "մնացել է",
  },
  profile_conditions: "Պայմանները",
  profile_pay: "Վճարել",
  profile_settings: "Կարգավորել",
  profile_automaticPaymentEnabled: "Միացված է ավտովճարումը",
  profile_paidFor: "Վճարված է մինչև {{val}}",
  profile_addingNewLicenses: "Նոր լիցենզիաների ավելացումը հասանելի",
  profile_WillBeAvailableAfterRenewal: "կլինի երկարաձգումից հետո",
  profile_add_new: "ավելացնել լիցենզիան",
  profile_extend: "Երկարացնել",
  profile_add: "Ավելացնել",
  profile_recurrentPaymentFailed: "Չհաջողվեց ելքագրել ավտովճարումը",
  profile_code: "Կոդ",

  search_participantsSearch: "ԱՏԻ մասնակիցների որոնում",
  search_atiParticipantsSearch: "ATI.SU մասնակիցների որոնում",
  search_advancedSearch: "Ընդյլայնված որոնում",
  search_advanced: "Ընդլայնված",
  search_phoneAndEmailRestriction:
    "Հեռախոսահամարով եւ այլ կոնտակտային տվյալներով որոնումը հասանելի է վճարովի մասնակիցներին:",
  search_pricesAndRates: "Գներ եւ սակագներ:",

  // nps
  nps_recomendChance:
    "Ի՞նչ հավանականությամբ դուք ATI.SU-ն խորհուրդ կտաք ձեր ծանոթներին։",
  nps_errorTryAgain:
    "Փորձեք ևս մեկ անգամ։ Պատասխանն ուղարկելիս տեղի է ունեցել սխալ։",
  nps_rateNoRecommend: "ոչ մի դեպքում խորհուրդ չեմ տա",
  nps_rateRecommend: "հաստատ խորհուրդ կտամ",
  nps_thanksForRate: "Շնորհակալություն պատասխանի համար ({{val}} - 10)",
  nps_commentYourAnswer: "Մեկնաբանեք պատասխանը",
  nps_send: "Ուղարկել",
  nps_tryAgain: "Փորձեք ևս մեկ անգամ։",
  nps_errorWhileSending: "Պատասխանն ուղարկելիս տեղի է ունեցել սխալ։",
  nps_answerSended:
    "Պատասխանն ուղարկված է։ Շնորհակալություն հարցմանը մասնակցլեու համար։",
  nps_youAlreadyVoted:
    "Դուք արդեն քվեարկել եք։ Շնորհակալություն հարցմանը մասնակցելու համար։",

  security_header: "Ի՞նչ եք կարծում՝ որքանով անվտանգ է աշխատել ATI.SU-ով:",
  security_rateNoRecommend: "բացարձակ ոչ անվտանգ",
  security_rateRecommend: "լիովին անվտանգ",
  security_headerSuccess: "Շնորհակալություն պատասխանի համար",
  security_headerDescription:
    "Ցանկության դեպքում կարող եք թողնել մեկնաբանություն",

  outdated_outdatedBrowserTitle: "Ձեր բրաուզերը կարող է աշխատել սխալներով",
  outdated_ieWasFound:
    "Ձեր բրաուզերը հնացել է: Որպեսզի ATI.SU Բորսան աշխատի առանց սխալների, խորհուրդ ենք տալիս տեղադրել հետևյալ  բրաուզերներից մեկը.",
  outdated_outdatedBrowserWasFound:
    "Ձեր բրաուզերը հնացել է: Որպեսզի ATI.SU Բորսան աշխատի առանց սխալների, թարմացրեք բրաուզերը:",
  outdated_update: "Թարմացնել",
  outdated_remindLater: "Հիշեցնել այդ մասին ավելի ուշ",
  outdated_howToUpdate: "Ինչպես թարմացնել բրաուզերը",
  outdated_howToInstallAnotherBrowser: "Ինչպես տեղադրել բրաուզերը",

  refresh_attemptsLimitError:
    "Превышено кол-во обновлений, повторите через 5 минут", // !

  notification_unsubscribePartnerText:
    "Դուք կարող եք {{val1}} կամ {{val2}} անջատել մեր գործընկերների բոլոր առաջարկները:",
  notification_unsubscribePartnerATISU:
    "ապաբաժանորդագրվել ATI.SU-ի այս գործընկերոջ տեղեկացումներից",
  notification_notificationsSettings: "ծանուցումների կարգավորումներից",

  feed_checkAll: "Բոլորը նշել՝ որպես ընթերցված",
  feed_allRead: "Բոլորը ընթերցված են",
  feed_showMessegesText: "Ցուցադրել մեսսենջերի հաղորդագրության տեքստը",
  feed_groupedMessageCounter: {
    one: "հաղորդագրություն(ներ)",
    few: "հաղորդագրություն",
    many: "հաղորդագրություն(ներ)",
    other: "հաղորդագրություն(ներ)",
  },

  mainMenu_analitics: {
    statistika_rynka: "Շուկայի վիճակագրությունը",
    servisy_dlya_analitiki: "Ծառայություններ վերլուծության համար",
    dinamika_rynka: "Շուկայի դինամիկան",
    rynok_v_cifrah: "Շուկան՝ թվերով",
  },

  menu_analitics_averageRates: "Միջին դրույքաչափեր",
  menu_analitics_cargomap: "Բեռների քարտեզ",
  menu_analitics_profitdirections: "Շահավետ ուղղություններ",
  menu_analitics_index: "Ինդեքս",

  /** Это группе строк не нужен перевод */
  languageInformer_title: "Выберите язык интерфейса",
  languageInformer_description:
    "Вы всегда сможете изменить свой выбор в кабинете или подвале сайта.",
  languageInformer_button: "Сохранить",
  /** Конец группы */
};
